import React from 'react'
import styled from 'styled-components';

const StyledProjectInfo = styled.div`
padding: 1em 3em;
display: flex;
justify-content: center;
align-items: flex-start;
margin-bottom: 3rem;
gap: 100px;
@media (max-width: 1200px) {
    flex-direction: column;
    align-items: center;
    gap: 30px;
    }
`;

const StyledInfo = styled.div`
    font-size: 1rem;
`;
const StyledPic = styled.img`
    max-width: 600px;
    margin: auto;
    transform: perspective(1500px) rotateY(-15deg);
    transition: all .5s;
    opacity: 0.7;
    &:hover {
        transform: perspective(3000px) rotateY(-5deg);
        opacity: 1;
    }
    @media (max-width: 1200px) {
            max-width: 400px;
            padding: 0 1em;
            transform: none;
            opacity: 1;
    }
`;

const StyledHeader = styled.div`
    &>h1 {
        font-size: 2rem;
        font-weight: 100;
    }
`;
const StyledLine = styled.div`
        height: 1px;
        background-color: black;
        width: 30%;
        margin: 1em 0 2em 0;
`;


const StyledActions = styled.div`
display: flex;
justify-content: center;
align-items: center;
text-align: center;
gap: 2.5rem;
padding:  0 1em 5rem 1em;
`;

const StyledHyperlink = styled.a`
    padding: 1em;
    background-color: ${props => props.maincolor};
    color: white;
    border-radius: 5px;

        transition: all .2s;
        opacity: 0.7;
        &:hover {
        opacity: 1;
        } 

`;
const StyledHyperlinkAccent = styled.a`
    padding: 1em;
    background-color: ${props => props.accentcolor};
    color: white;
    border-radius: 5px;
        transition: all .2s;
        opacity: 0.7;
        &:hover {
        opacity: 1;
        } 

`;

export default function ProjectInfo({ children, pic, title, maincolor, accentcolor, link, githublink }) {
    return (
        <>
            <StyledProjectInfo>
                <StyledHeader>
                    <h1>{title}</h1>
                    <StyledLine />
                    <StyledInfo>
                        {children}
                    </StyledInfo>
                </StyledHeader>
                <a href={link} target="_blank" rel='noreferrer' ><StyledPic src={pic} alt="a pic of a project about airplane costs" /></a>
            </StyledProjectInfo>
            <StyledActions>
                <StyledHyperlink maincolor={maincolor} accentcolor={accentcolor} href={link} target="_blank" rel='noreferrer' >Demo The Project</StyledHyperlink>
                <StyledHyperlinkAccent accentcolor={accentcolor} href={githublink} target="_blank" rel='noreferrer' >Check out the project here on GitHub</StyledHyperlinkAccent>
            </StyledActions>
        </>
    )
}
